var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.182,
    height: 24.182,
    viewBox: "0 0 24.182 24.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28045",
    "data-name": "Group 28045",
    transform: "translate(-1149.5 -462.921)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1726",
    "data-name": "Ellipse 1726",
    cx: 12.091,
    cy: 12.091,
    r: 12.091,
    transform: "translate(1149.5 462.921)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_location",
    "data-name": "vuesax/bold/location",
    transform: "translate(725.5 278.921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.667,4.467A5.75,5.75,0,0,0,5.92,0H5.913A5.749,5.749,0,0,0,.167,4.46C-.613,7.9,1.493,10.813,3.4,12.647a3.615,3.615,0,0,0,5.033,0C10.34,10.813,12.447,7.907,11.667,4.467ZM5.92,7.807a2.1,2.1,0,1,1,2.1-2.1A2.1,2.1,0,0,1,5.92,7.807Z",
    transform: "translate(430.08 189.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H16V16H0Z",
    transform: "translate(428 188)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H16V16H0Z",
    transform: "translate(444 204) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationCircle);
export default __webpack_public_path__ + "static/media/location-circle.9b45a2d05b1a6e270c976c7a90f7d218.svg";
export { ForwardRef as ReactComponent };